
import React from 'react';

interface HeaderProps {
  isAdminLoggedIn: boolean;
  isMemberLoggedIn: boolean;
  onAdminLogout?: () => void;
  onMemberLogout?: () => void;
}


const Header: React.FC<HeaderProps> = ({ isAdminLoggedIn, isMemberLoggedIn, onAdminLogout, onMemberLogout }) => (
  <header className="w-full bg-blue-700 text-white h-16 px-8 shadow-md z-30 flex items-center relative" style={{ minHeight: '4rem' }}>
    <div className="w-full flex justify-center items-center h-full">
      <h1 className="text-2xl font-bold tracking-wide">Club Member Admin</h1>
    </div>
    {(isAdminLoggedIn || isMemberLoggedIn) && (
      <button
        className="absolute right-8 top-1/2 -translate-y-1/2 bg-red-500 hover:bg-red-700 text-white font-bold py-1.5 px-4 rounded-md shadow-lg transition duration-200 h-10 flex items-center"
        style={{ minHeight: '2.5rem', top: '50%', transform: 'translateY(-50%)' }}
        onClick={isAdminLoggedIn ? onAdminLogout : onMemberLogout}
      >
        Logout
      </button>
    )}
  </header>
);

export default Header;
